import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import AnimationLayout from '../../components/AnimationLayout'
import MatildeBalloon from '../../components/MatildeBalloon'
import Bag from './Bag'
import Hats from './Hats'
import Button from '../../components/Button'
import { Link, useLocation } from 'react-router-dom'

const Inventory = () => {
    const mainInventoryLinks = [
        ['Mochila', 'bag', 'menu-items'],
        ['Guarda-chapéus', 'hats', 'menu-hats'],
    ]

    const [state, setState] = useState({
        active: '',
        animation: false
    })

    const location = useLocation()
    const user = useSelector(state => state.apiCalls.apiData.user)
    const loggedUser = useSelector(state => state.firebase.profile)
    const isLoggedInUserProfile = user?.username ? false : true
    const userObject = user?.username ? user : loggedUser

    const variants = {
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: 'easeInOut'
            }
        },
        endAnimate: {
            opacity: 0,
            y: 10,
            transition: {
                duration: 0.5,
                ease: 'easeInOut'
            }
        }
    }

    return (
        <AnimationLayout>
            <h1 className='w-full'>{isLoggedInUserProfile ? 'Os meus Itens' : 'Itens'}</h1>
            {isLoggedInUserProfile &&
                <MatildeBalloon>
                    <p className='text-left'>
                        Aqui poderá visualizar os seus itens, os que estão na sua mochila e no seu guarda-chapéus. Na sua mochila encontrará itens para utilizar nas suas narrativas, já no guarda-chapéus terá chapéus para decorar o seu avatar.
                    </p>
                </MatildeBalloon>
            }
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-8 lg:gap-12 mb-12">
                {mainInventoryLinks.map((item, index) =>
                    <div
                        key={index}
                        onClick={() => {
                            setState({ ...state, animation: true })
                            setTimeout(() => {
                                setState({ animation: false, active: item[1] })
                            }, 500)
                        }}
                        className={`image-button usable w-full flex flex-col items-center justify-center pt-3`}
                    >
                        <img alt={item[0]} className='object-contain' src={`${require(`../../assets/img/${item[2]}.png`)}`} />
                        <h2 className='pt-3'>{item[0]}</h2>
                    </div>
                )}
            </div>


            <motion.div
                animate={state.animation ? 'endAnimate' : 'animate'}
                variants={variants}
            >
                {state.active !== '' ?
                    state.active === 'bag' ?
                        <Bag items={userObject.inventory.bag} isLoggedUser={isLoggedInUserProfile} />
                        :
                        <Hats hats={userObject.inventory.hats} isLoggedUser={isLoggedInUserProfile} />
                    :
                    <div></div>
                }
            </motion.div>

            <Link to={location.state.from}>
                <Button className='back-button rounded-full mr-0'>
                    <img src={require('../../assets/icons/32/arrow-left-32.png')} alt='Voltar' />
                </Button>
            </Link>
        </AnimationLayout>
    )
}

export default Inventory
